import { Color, Value } from "theme/style"

const style = {
  root: {
    borderRadius: Value.BorderRadius_Field + '! important',
  },
  button: {
    '& span': {
      '& span': {
        color: Color.TextLight + ' !important'
      },
    },
    '&:hover': {
      backgroundColor: Color.Background
    }
  }
}

export default style
